import { UUID } from "crypto";
import { baseApi } from "./baseApi";

const extrasApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        postExtractoProspectos: build.mutation<any, UUID>({
            query: (loanApplicationId) => ({
                url: "extracto/prospectos_cuadro_accionario",
                method: "POST",
                body: {
                    loan_application_id: loanApplicationId,
                },
            }),
        }),
    }),
});

export const { usePostExtractoProspectosMutation } = extrasApi;
